import React from "react";
import { motion } from "framer-motion";
import "../../styles/AboutSection.css";
import AboutDepthXRVisual from "./AboutDepthXRVisual";
import {
  sectionStagger,
  fadeUpItem,
  revealViewport,
} from "../animations/animationVariants";

const AboutSection = () => {
  return (
    <>
    <div className="about-hero">
      <img className="hero-bg" src="../../image/main-Logo2.png" alt="Biiyeoen배경" />
      <div className="hero-gredient" />
      <div className="hero-content">
        <h1 className="big-title">Beyond Connection</h1>
        <p className="hero-eyebrow">공간과 경험의 경계를 허무는 크리에이티브 테크 랩</p>
      </div>
    </div>
    <div className="home-container">
        <motion.div
          className="weare-container"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <span className="section-eyebrow">01 / About</span>
          <span className="weare-text">WE ARE</span>
          <span className="biiyeon-text">BIIYEON<em className="biiyeon-dot">.</em></span>
        </motion.div>

        <motion.div
          className="mission-wrapper"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <div className="mission-line" />
          <p className="mission-text">
            예술의 가능성을 넓히는, <strong>테크 기반</strong> 아트 프로젝트팀
          </p>
          <div className="mission-line" />
        </motion.div>

        <section className="home-about-depth" id="about">
          <div className="home-about-depth__sr-only">
            <p>
              <strong>비전.</strong> 현실과 가상을 초연결하는 몰입형 생태계. BIIYEON은 공간의 물리적 한계를 지우고,
              사람과 예술, 브랜드가 시공간의 제약 없이 교감하는 새로운 차원의 경험을 설계합니다.
            </p>
            <p>
              <strong>실행.</strong> 세상을 연결하는 XR 크리에이티브 랩. 우리는 단순한 기술 실험에 머물지 않습니다.
              공간 컴퓨팅과 원천 기술 연구를 바탕으로, 일상 속 몰입의 기준을 바꾸는 혁신적인 플랫폼을 끊임없이 세상에
              선보입니다.
            </p>
          </div>
          <motion.div
            className="home-about-depth__body"
            variants={fadeUpItem}
            initial="hidden"
            whileInView="visible"
            viewport={revealViewport}
          >
            <AboutDepthXRVisual />
          </motion.div>

          <motion.div
            className="home-about-depth__cards"
            variants={sectionStagger}
            initial="hidden"
            whileInView="visible"
            viewport={revealViewport}
          >
            <motion.div className="home-about-depth__card" variants={fadeUpItem}>
              <h3 className="home-about-depth__card-title">서비스 &amp; 플랫폼 (Services &amp; Platform)</h3>
              <p>
                연구실의 기술을 현실의 서비스로 구현합니다. 누구나 쉽게 차원이 다른 몰입형 경험을 제작하고 배포할 수
                있도록, 우리는 멈추지 않고 혁신적인 솔루션과 플랫폼 생태계를 확장해 나갑니다.
              </p>
            </motion.div>
            <motion.div className="home-about-depth__card" variants={fadeUpItem}>
              <h3 className="home-about-depth__card-title">미래 기술 연구 &amp; 실험 (R&amp;D)</h3>
              <p>
                현재에 머물지 않고 다음 세대의 기술을 발굴합니다. 공간 컴퓨팅과 XR 원천 기술을 자체적으로 연구하며,
                하드웨어와 소프트웨어를 아우르는 한계 없는 융합 실험을 지속합니다.
              </p>
            </motion.div>
          </motion.div>
        </section>

        <motion.p
          className="home-about-depth__bridge"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          포트폴리오·Aura·문의는 아래 섹션에서 이어집니다.
        </motion.p>

      </div>
    </>
  );
};

export default AboutSection;
